export const GET_RIDES = 'GET_RIDES';

// Get journeys (via saga)
export const getRides = (locationType = 'input', startLat, startLng) => {
	return {
		type: 'GET_RIDES',
		options: {
			locationType,
			startLat,
			startLng
		}
	}
}

// Put journeys (from saga)
export const putRides = (rides = []) => {
	return {
		type: 'PUT_RIDES',
		payload: {
			rides,
		}
	}
}

// Clear journeys
export const clearRides = (rides = []) => {
	return {
		type: 'CLEAR_RIDES',
		payload: {
			rides,
		}
	}
}



// WEBPACK FOOTER //
// ./src/actions/rides.js